import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Collapse from 'react-bootstrap/Collapse';
import './stylevn.css';
import SidebarVN from '../../../container/Sidebar/Sidebar-vn';
import { AiOutlineMenu } from 'react-icons/ai';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Dropdown from 'react-bootstrap/Dropdown';
import { useHistory } from 'react-router-dom';
import { DropdownButton } from 'react-bootstrap';

const navItems = [
    { text: 'Private Cloud', href: 'https://hanbiro.com/#/en/private-cloud#cluster', active: true },
    { text: 'Services', href: 'https://hanbiro.com/#/en/home#services', },
    { text: 'Groupware', href: 'https://hanbiro.com/#/en/home#groupware' },
    { text: 'Contact', href: 'https://hanbiro.com/#/en/home#contact' },
];

function HeaderEn() {
    const [show, setShow] = useState(false);
    const [open, setOpen] = useState(false);
    const history = useHistory();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleLanguageChange = (path) => {
        history.push(path);
    };

    const renderNavList = () => (
        <div className="navbar-list">
            <ul className="navbar-nav">
                {navItems.map((item, index) => (
                    <li className="nav-item" key={index}>
                        <a
                            className={`nav-link txt-14 ${item.active ? 'active' : ''}`}
                            aria-current={item.active ? 'page' : undefined}
                            href={item.href}
                        >
                            {item.text}
                        </a>
                    </li>
                ))}
            </ul>
            <div className="head-drop-sub">
                <DropdownButton
                    align="end"
                    title="English"
                    id="dropdown-menu-align-end"
                >
                    <Dropdown.Item href="https://hanbiro.vn">Vietnamese</Dropdown.Item>
                    <Dropdown.Item href="https://hanbiro.com">Korean</Dropdown.Item>
                </DropdownButton>
            </div>
        </div>
    );

    return (
        <>
            <div className="head-vn head-vn-desk">
                <div className="fit-block">
                    <div className="nav-vn">
                        <a href="https://hanbiro.com/#/en/home"><img src="https://hanbiro.com/cloud/library/banner/hanbiro.svg" alt="error" /></a>
                        {renderNavList()}
                    </div>
                </div>
            </div>

            <div className="header-vn-mb">
                <div className="fit-block nav-vn-block">
                    <div className="nav-vn">
                        <Button variant="primary" onClick={handleShow}>
                            <AiOutlineMenu className="icon-menu" />
                        </Button>

                        <Offcanvas show={show} onHide={handleClose} placement="top" className="sidebar-menu">
                            <Offcanvas.Header closeButton />
                            <Offcanvas.Body>
                                <SidebarVN />
                            </Offcanvas.Body>
                        </Offcanvas>
                        <a href="https://hanbiro.com/#/en/home"><img src="https://hanbiro.com/cloud/library/banner/hanbiro.svg" alt="error" /></a>
                    </div>

                    <div className="head-dropdown">
                        <Button onClick={() => setOpen(!open)} aria-controls="collapse-header" aria-expanded={open}>
                            <MoreVertIcon className="icon-menu" />
                        </Button>
                    </div>
                </div>

                <Collapse in={open}>
                    <div id="collapse-header">
                        {renderNavList()}
                    </div>
                </Collapse>
            </div>
        </>
    );
}

export default HeaderEn;
